'use client'

import PropTypes from 'prop-types'
import MUITab from '@mui/material/Tab'
import MUITabs from '@mui/material/Tabs'
import styles from './MatterDrawerTopTabs.module.scss'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'

export const MatterDrawerTopTabs = ({ selectedTab, isClientOnly = false, isClientWorkspace = false, onChange }) => {
  const { allowedMenuIds } = useMenuItemsStore()

  return (
    <MUITabs
      data-testid="MatterDrawerTopTabs"
      value={selectedTab}
      onChange={onChange}
      aria-label="Details"
      className={styles.matterDrawerTabs}
      sx={{
        borderBottom: '1px solid #CFD8DC',
        padding: '0 16px',
        mt: '0px',
        height: '22px',
        '> div': { height: '22px' },
        '.MuiTabScrollButton-root': { opacity: 0.3 }
      }}
      variant="scrollable"
      scrollButtons="auto"
    >
      <MUITab
        label="Matter"
        role="tab"
        className={styles.matterDrawerTab}
        value="matter"
        sx={{ display: !isClientOnly && !isClientWorkspace ? 'flex' : 'none' }}
      />

      <MUITab
        label="Matter ext."
        role="tab"
        className={styles.matterDrawerTab}
        value="matterExt"
        sx={{ display: !isClientOnly && !isClientWorkspace && allowedMenuIds.includes(1200) ? 'flex' : 'none' }}
      />

      <MUITab label="Client" role="tab" className={styles.matterDrawerTab} value="client" />

      <MUITab
        label="Client ext."
        role="tab"
        className={styles.matterDrawerTab}
        value="clientExt"
        sx={{ display: allowedMenuIds.includes(1100) ? 'flex' : 'none' }}
      />

      <MUITab
        label="Related"
        role="tab"
        className={styles.matterDrawerTab}
        value="related"
        sx={{ display: allowedMenuIds.includes(1287) ? 'flex' : 'none' }}
      />
    </MUITabs>
  )
}

MatterDrawerTopTabs.propTypes = {
  selectedTab: PropTypes.any,
  isClientOnly: PropTypes.bool,
  isClientWorkspace: PropTypes.bool,
  onChange: PropTypes.func
}
